import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import moment from 'moment';
import Loader from '../../../components/ui/Loader/Loader';
import axios from 'axios';
import { Modal } from 'bootstrap';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
    iconUrl: require("leaflet/dist/images/marker-icon.png").default,
    shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
});

const TripSessionDetail = (props) => {
    const modalRef = useRef(null);
    const modalInstance = useRef(null);
    const mapContainerRef = useRef(null);
    const leafletMapRef = useRef(null);
    const [coords, setCoords] = useState(null);
    const [mapReady, setMapReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tripData, setTripData] = useState([]);

    const [modalShown, setModalShown] = useState(false);

    useEffect(() => {
        if (modalRef.current) {
            modalInstance.current = new Modal(modalRef.current, {
                keyboard: false,
                backdrop: true
            });

            modalRef.current.addEventListener('shown.bs.modal', () => setModalShown(true));
            modalRef.current.addEventListener('hidden.bs.modal', () => {
                setModalShown(false);
                setMapReady(false);
            });
        }

        return () => {
            modalInstance.current?.dispose();
        };
    }, []);

    useEffect(() => {
        if (props?.assetDetail?.iot_device_imei && props?.shiftDetail) {

            fetchTripData();
        }
    }, [props?.shiftDetail]);

    const openMapModal = (lat, lng) => {
        setMapReady(false);
        setCoords({ lat, lng });
        modalInstance.current?.show();
    };

    useEffect(() => {
        if (!modalShown || !coords || !mapContainerRef.current) return;

        if (leafletMapRef.current) {
            leafletMapRef.current.remove();
            leafletMapRef.current = null;
        }

        const map = L.map(mapContainerRef.current, {
            zoomControl: true,
            attributionControl: false,
            preferCanvas: true
        }).setView([coords.lat, coords.lng], 15);

        leafletMapRef.current = map;

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);

        const customIcon = L.icon({
            iconUrl: require("leaflet/dist/images/marker-icon.png").default,
            iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
            shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        L.marker([coords.lat, coords.lng], { icon: customIcon })
            .addTo(map)

        setTimeout(() => {
            map.invalidateSize();
            setMapReady(true);
        }, 100);

        return () => {
            if (leafletMapRef.current) {
                leafletMapRef.current.remove();
                leafletMapRef.current = null;
            }
        };
    }, [modalShown, coords]);

    const tripDataModalClose = () => {
        modalInstance.current?.hide();
        setCoords(null);
        setMapReady(false);
        setModalShown(false);

        if (leafletMapRef.current) {
            leafletMapRef.current.remove();
            leafletMapRef.current = null;
        }
    };

    const fetchTripData = () => {
        setLoading(true)
        const shift = props?.shiftDetail?.shift;
        const startMoment = moment(
            `${shift?.shift_date} ${shift?.shift_start_his}`,
            "YYYY-MM-DD HH:mm:ss"
        );
        const endMoment = moment(startMoment).add(shift?.seconds, 'seconds');

        const now = moment();
        const finalEndMoment = endMoment.isAfter(now) ? now : endMoment;

        const requestBody = {
            imeIs: [props?.assetDetail?.iot_device_imei],
            startDate: startMoment.toISOString(),
            endDate: finalEndMoment.toISOString()
        };

        axios.post(`https://api6.tappetbox.in/api/Report/trip-session?closeOpenAtEnd=false`, requestBody)
            .then(response => {
                setTripData(response.data || []);
            })
            .catch(error => {
                console.error("Error fetching device data:", error);
            }).finally(
                setLoading(pre => !pre)

            )
    };

    const renderTripData = () => {
        const trips = tripData;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="tab_content_wrapper fw-bold mb-3">
                        Trip Details
                    </div>
                    {props?.shiftDetailLoading ? <Loader /> :
                        <table className="table table-bordered mb-0 table-hover mt-2">
                            <thead className="table-light">
                                <tr className='text-center'>
                                    <th style={{ width: "6%" }}>#</th>
                                    <th style={{ width: "14%" }}>Start Time</th>
                                    <th style={{ width: "18%" }}> Start Location</th>
                                    <th style={{ width: "14%" }}>Stop Time</th>
                                    <th style={{ width: "18%" }}> Stop Location</th>
                                    <th style={{ width: "10%" }}>Total Duration</th>
                                    <th style={{ width: "15%" }}>Total KM Running</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? <tr><td className='text-center' colSpan={7}><Loader /> </td></tr>:
                                    trips.length > 0 ?
                                        trips.map((trip, tripIndex) => (
                                            <tr key={tripIndex} className='text-center'>
                                                <td>Trip {tripIndex + 1}</td>
                                                <td>
                                                    {trip?.startTimestamp ?
                                                        moment(trip.actualStartTimestamp).format('DD-MMM-YYYY HH:mm')
                                                        : 'N/A'
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        trip?.startLat != null && trip?.startLong != null && trip?.startLocation ?
                                                            <span
                                                                className="text-primary"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => openMapModal(trip.startLat, trip.startLong)}
                                                            >
                                                                {trip.startLat} , {trip.startLong}
                                                            </span> : 'N/A'
                                                    }
                                                </td>
                                                <td>
                                                    {trip?.stopTimestamp ?
                                                        moment(trip.actualStopTimestamp).format('DD-MMM-YYYY HH:mm')
                                                        : 'N/A'
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        trip?.stopLat != null && trip?.stopLong != null && trip?.stopLocation ?
                                                            <span
                                                                className="text-primary"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => openMapModal(trip.stopLat, trip.stopLong)}
                                                            >
                                                                {trip.stopLat} , {trip.stopLong}
                                                            </span> : 'N/A'
                                                    }
                                                </td>
                                                <td><strong>{trip?.totalDuration || 'N/A'}</strong></td>
                                                <td>
                                                    <strong>
                                                        {trip?.totalKmRunning ? `${trip.totalKmRunning} km` : 'N/A'}
                                                    </strong>
                                                </td>
                                            </tr>
                                        ))
                                        : <tr><td className='text-center' colSpan={7}>No Record Found</td></tr>}
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        );
    };

    const tripModalJsx = () => {
        return (
            <div className="modal fade" tabIndex="-1" ref={modalRef}>
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold">Trip Location</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={tripDataModalClose}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-3" style={{ height: "80vh" }}>
                            <div
                                className="map-wrapper"
                                style={{
                                    height: "100%",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    border: "1px solid #dee2e6",
                                    position: "relative"
                                }}
                            >
                                <div
                                    ref={mapContainerRef}
                                    style={{ width: "100%", height: "100%" }}
                                />

                                {!mapReady && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 1000
                                    }}>
                                        <Loader />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet><title>Trip Data</title></Helmet>
            <div className="row pl2">
                <div className="bg-white p-3">
                    {renderTripData()}
                </div>
            </div>
            {tripModalJsx()}
        </>
    );
};

export default TripSessionDetail;